export default "__VITE_ASSET__2aEGkAdV__"